module.exports = __webpack_public_path__ + "media/images/about-us-mask-d3bd3710db4daadc096d5c3dd7a6d0d2.svg";